/* eslint-disable no-param-reassign */
import {
  SET_OPERATION_PROPERTY,
  RESET_OPERATION_DATA,
  ADD_CONTACT_PROSPECT,
  DELETE_CONTACT_PROSPECT,
  COPY_DATA_CONTACT_TO_ATTORNEY,
  SET_CUSTOMER_TYPE_OPERATION,
  CREATE_OPERATION_DATA_TO_SEND,
  DELETE_DATA_TO_SEND,
  RESET_PROSPECTB2B_DATA
} from 'store/actions/operation';
import { DATA_OPERATION, DOCUMENT_TYPES } from 'store/enums';
import { setValueObjectByField } from 'helpers/object';
import { dateToISO } from 'helpers/date';
import validateSpanishId from '@/validators/rules/validateSpanishId';

export default {
  [SET_OPERATION_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
    // Check single field
    const lastIndex = field.lastIndexOf('.');
    const pathFielName = field.substring(0, lastIndex);
    const fieldName = field.substring(lastIndex + 1, field.length);
    // Condition for fields equal to some value
    if (fieldName === 'postalCode') {
      setValueObjectByField(state, `${pathFielName}.provinceCode`, value.substring(0, 2));
    }
    // Equals documentId field
    if (fieldName === 'documentId' && pathFielName.indexOf('companyData') === -1) {
      const { type, valid } = validateSpanishId(value.toUpperCase());
      if (valid) {
        setValueObjectByField(
          state,
          `${pathFielName}.documentType`,
          DOCUMENT_TYPES[type.toUpperCase()]
        );
      }
    }
  },

  [DELETE_CONTACT_PROSPECT]: (state, { index }) => {
    if (index) {
      state.prospect.contact.pop();
    }
  },

  [DELETE_DATA_TO_SEND]: state => {
    if (state.dataToSend) delete state.dataToSend;
  },

  [ADD_CONTACT_PROSPECT]: state => {
    state.prospect.contact.push({
      contactType: DATA_OPERATION.CONTACT_TYPE.ATTORNEY,
      documentType: 0,
      documentId: '',
      name: '',
      lastname: '',
      lastname2: '',
      genre: '',
      address: {
        streetType: '',
        address1: '',
        postalCode: '',
        provinceCode: '',
        cityCode: ''
      },
      email: '',
      mobile: '',
      signType: ''
    });
  },

  [COPY_DATA_CONTACT_TO_ATTORNEY]: state => {
    const { name, lastname, lastname2, email, mobile, address, genre } = JSON.parse(
      JSON.stringify(state.prospect.contact[0])
    );
    const prospectTo = state.prospect.contact[1];
    prospectTo.name = name;
    prospectTo.lastname = lastname;
    prospectTo.lastname2 = lastname2;
    prospectTo.email = email;
    prospectTo.mobile = mobile;
    prospectTo.genre = genre;
    prospectTo.address = address;
    prospectTo.contactType = DATA_OPERATION.CONTACT_TYPE.ATTORNEY;
  },

  [SET_CUSTOMER_TYPE_OPERATION]: (state, { value }) => {
    setValueObjectByField(
      state,
      'customerType',
      value ? DATA_OPERATION.CUSTOMER_TYPE.COMPANY : DATA_OPERATION.CUSTOMER_TYPE.PARTICULAR
    );
  },

  [RESET_OPERATION_DATA]: state => {
    state.customerType = DATA_OPERATION.CUSTOMER_TYPE.PARTICULAR;
    state.idC = null;
    state.renovationPlate = '';
    state.prospect = {
      contact: [
        {
          contactType: DATA_OPERATION.CONTACT_TYPE.CONTACT,
          documentType: 0,
          documentId: '',
          name: '',
          lastname: '',
          lastname2: '',
          genre: '',
          maritalStatus: null,
          jobType: null,
          address: {
            address1: '',
            postalCode: '',
            provinceCode: '',
            cityCode: ''
          },
          email: '',
          phone: '',
          mobile: '',
          chkRobinson: false,
          chkTermsAndConditions: true,
          chkDataTransfer: false,
          chkProactive: false,
          birthDate: '',
          driverLicenseIssuedDate: ''
        }
      ]
    };
    state.companyData = {
      name: '',
      documentId: '',
      constitutionDate: '',
      address: {
        streetType: '',
        address1: '',
        postalCode: '',
        provinceCode: '',
        cityCode: ''
      },
      phone: '',
      email: '',
      fax: ''
    };
    state.chkPartnerConfirmation = false;
    if (state.dataToSend) delete state.dataToSend;
    if (state.cancelOtherOperations) delete state.cancelOtherOperations;
  },

  [RESET_PROSPECTB2B_DATA]: state => {
    state.prospectB2B = {
      contact: [
        {
          email: '',
          cif: '',
          businessName: '',
          chkPartnerConfirmation: false
        }
      ]
    };
  },

  [CREATE_OPERATION_DATA_TO_SEND]: (state, { partnerId, idC, name, contactId }) => {
    state.user = name;
    state.partnerId = partnerId;
    if (idC) {
      state.idC = Number(idC);
    } else {
      delete state.idC;
    }

    if (contactId) {
      state.contactId = Number(contactId);
    } else {
      delete state.contactId;
    }

    // Clone object state for send and create a new operation
    state.dataToSend = JSON.parse(JSON.stringify(state));
    delete state.dataToSend.prospectB2B;

    // Transform data for send in the endpoint
    if (state.dataToSend.customerType === DATA_OPERATION.CUSTOMER_TYPE.PARTICULAR) {
      delete state.dataToSend.companyData;
    } else {
      state.dataToSend.companyData.constitutionDate = dateToISO(
        state.dataToSend.companyData.constitutionDate
      );
    }
    state.dataToSend.prospect.contact.forEach(element => {
      /* eslint-disable no-param-reassign */
      const { birthDate, driverLicenseIssuedDate } = element;
      if (birthDate) element.birthDate = dateToISO(birthDate);
      if (driverLicenseIssuedDate)
        element.driverLicenseIssuedDate = dateToISO(driverLicenseIssuedDate);
    });
  }
};
